export default __webpack_public_path__ + "static/media/cloudy.b76694a8.svg";